export default __webpack_public_path__ + "static/media/YUAN300_360.3ba7376f.jpg";